import { ACTION_DEPOSIT_EDIT, MUTATION_DEPOSIT_EDIT } from "./types";

export default {
    [ACTION_DEPOSIT_EDIT]: ({ commit }, data) => {
        commit(MUTATION_DEPOSIT_EDIT, {});
        commit(MUTATION_DEPOSIT_EDIT, data);
    }
}
